import { render, staticRenderFns } from "./Lista-Utenti.vue?vue&type=template&id=05af7dc0&scoped=true&"
import script from "./Lista-Utenti.vue?vue&type=script&lang=js&"
export * from "./Lista-Utenti.vue?vue&type=script&lang=js&"
import style0 from "./Lista-Utenti.vue?vue&type=style&index=0&id=05af7dc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05af7dc0",
  null
  
)

export default component.exports